import { useCallback } from "react";
import { getWorkOrderPermit } from "../../api/WorkOrders";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetPermits() {
  const setPermits = useWorkOrderStore((state) => state.setWoCompletedPermits);

  const getPermits = useCallback(
    async (woNumber: string) => {
      const response = await getWorkOrderPermit(woNumber);
      if (!response.isError) {
        setPermits(woNumber, response.data?.CompletePermitDetails ?? []);
      }
      return response;
    },
    [setPermits]
  );

  return { getPermits };
}
